import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import heroBg from "../../assets/img/about/about_banner.webp";
import { IHomeBannerData } from "../../exports/interfaces";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const HomeBanner = (props: { homeBanner: IHomeBannerData[] }) => {
  const banners = props.homeBanner || [];

  const getBannerImageUrl = (banner: IHomeBannerData) => {
    const image = banner.image?.[0]?.media;
    if (!image) return "";
    return image.url
      ? `${process.env.REACT_APP_cmsUrl}${image.url}`
      : `${process.env.REACT_APP_cmsUrl}/uploads/${image.name}`;
  };

  return (
    <>
      <Swiper
        modules={[Navigation, Autoplay, Pagination, EffectFade]}
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        navigation={true}
        pagination={{ clickable: true }}
        effect="fade"
        className="home-banner-swiper"
      >
        {(banners.length
          ? banners
          : [
              {
                title: "",
                sub_title: "",
                description: "",
                image: [],
                button_text: "",
                button_redirect_link: "",
              },
            ]
        ).map((banner, index) => {
          const imageUrl = getBannerImageUrl(banner);
          const titleWords = banner.title?.split(" ") || [];
          return (
            <SwiperSlide key={`home-banner-${index}`}>
              <section
                className="td_hero td_style_1 td_heading_bg td_center td_bg_filed"
                style={{
                  backgroundImage: `url(${imageUrl || heroBg})`,
                  height: "100dvh",
                }}
              >
                <div className="container td_mt_300">
                  <div
                    className="td_hero_text wow fadeInRight"
                    data-wow-duration="0.9s"
                    data-wow-delay="0.35s"
                  >
                    <h1 className="td_hero_title td_fs_32 td_white_color td_mb_12">
                      <span>{titleWords.slice(0, 4).join(" ")}</span>
                      {titleWords.length > 4 && <br />}
                      {titleWords.slice(4).join(" ")}
                    </h1>
                    {banner.description && (
                      <p
                        className="td_hero_subtitle td_fs_18 td_white_color td_mb_30"
                        dangerouslySetInnerHTML={{
                          __html: banner.description,
                        }}
                      ></p>
                    )}
                    {banner.sub_title && (
                      <h1 className="td_hero_title td_fs_16 td_white_color td_mb_12 td_medium font-source-sans">
                        <span>{banner.sub_title}</span>
                      </h1>
                    )}
                    <Link
                      to={banner.button_redirect_link || "/"}
                      className="td_btn td_style_1 td_radius_10 td_medium"
                    >
                      <span className="td_btn_in td_white_color td_orange_bg">
                        <span>{banner.button_text}</span>
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.1575 4.34302L3.84375 15.6567"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="td_lines">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </section>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default HomeBanner;
